<template lang="html">
  <div class="studio-tabs">
    <ul class="studio-tabs__header">
      <li
        v-for="(tab, index) in tabs"
        :key="tab.title"
        class="studio-tabs__tab"
        :class="{'studio-tabs__tab-selected': (index === selectedIndex)}"
        @click="selectTab(index)"
      >
        {{ tab.title }}
      </li>
    </ul>
    <slot />
  </div>
</template>

<script>

export default {
  name: 'Tabs',
  props: {
    listItems: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      selectedIndex: 0,
      tabs: this.listItems,
    };
  },
  mounted () {
    this.selectTab(this.selectedIndex);
  },
  methods: {
    selectTab (i) {
      this.selectedIndex = i;
      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i);
      });
      this.$emit('selected-index', i);
    },
  },
};
</script>

<style lang="scss">

  .studio-tabs {
    &__header {
      display: flex;
      margin-bottom: var(--ds-spacing-stack-sm);
      list-style: none;
      padding-left: 0 !important;
    }

    &__tab {
      display: flex;
      align-items: center;
      color: var(--ds-color-text-1);
      margin-right: var(--ds-spacing-stack-xs);
      height: var(--ds-spacing-stack-md);
      padding: 0 var(--ds-spacing-stack-sm);
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xs);
      line-height: var(--ds-font-size-baseline);
      cursor: pointer;
      border: 1px solid transparent;
      border-radius: 20px;
      transition: 0.3s;

      &:hover {
        background: var(--ds-color-secondary-button-hover);
      }
    }

    &__tab-selected {
      background: var(--ds-color-secondary-button-hover);
      border-color: var(--ds-color-icon-2);
    }
  }

</style>
